<template>
  <div :class="chapterClass">
    <div class="Chapter__bar">
      <Heading type="3">
        {{ content.chapter }}. {{ content.shortName }}
      </Heading>
      <StdButton :context="buttonContext" :icon="isOpen ? 'chevron-up' : 'chevron-down'" :onClick="toggleOpen" >
        {{ buttonText }}
      </StdButton>
    </div>
    <div class="Chapter__content">
      <p class="Chapter__description">
        {{ content.fullName }}
      </p>
      <div class="Chapter__content-slot" v-for="(item, index) in chapterData" v-bind:key="index">
        <div class="Chapter__text-slot" v-if="item.type === CTYPES.TEXT" v-html="item.content" ></div>
        <ExcelTable v-if="item.type === CTYPES.XLSX" :table="item.htmlTable" />
        <StdTable v-if="item.type === CTYPES.TABLE" :identifier="index" :content="item.content" />
        <StdImage v-if="item.type === CTYPES.IMAGE" :identifier="index" :src="item.fileUrl" />
        <Pdf v-if="item.type === CTYPES.PDF" :identifier="index" :src="item.fileUrl" />
      </div>
      <p class="Chapter__meta" v-if="date">
        <strong>{{ LAST_UPDATE_ON }}</strong>&nbsp;<time>{{ date }}</time>
      </p>
      <p class="Chapter__meta" v-else>
        <strong>{{ NO_ENTRIES_YET }}</strong>
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Heading } from './../Heading'
import { ExcelTable } from './../ExcelTable'
import { StdButton } from './../StdButton'
import { StdImage } from './../StdImage'
import { StdTable } from './../StdTable'
import { Pdf } from './../Pdf'
import { GENERAL } from './../../locales/es'
moment.locale('es')
export default {
  components: {
    Heading,
    ExcelTable,
    StdButton,
    StdImage,
    StdTable,
    Pdf,
  },
  props: {
    content: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      ...GENERAL,
      isOpen: false,
    }
  },
  computed: {
    chapterClass() {
      return this.isOpen ? `Chapter Chapter--open` : 'Chapter'
    },
    buttonContext() {
      return this.isOpen ? 'outline' : 'default'
    },
    buttonText() {
      return this.isOpen ? this.HIDE_INFO : this.SEE_INFO
    },
    lastEntry() {
      return this.content.entries[0]
    },
    chapterData() {
      return this.lastEntry ? this.lastEntry.data : []
    },
    date() {
      return this.lastEntry ? moment(this.lastEntry.created_at).format('LL') : ''
    }
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    }
  }
}
</script>

<style>
.Chapter {
  background: #bed1c7;
  border-radius: 3px;
  box-sizing: border-box;
  height: 68px;
  margin-bottom: 26px;
  overflow: hidden;
  padding: 0 16px;
  width: 100%;
}

.Chapter--open {
  height: auto;
}

.Chapter__bar {
  height: 68px;
  padding-right: 206px;
  position: relative;
}

.Chapter__bar h3 {
  line-height: 68px;
  font-size: 1.1em;
  margin: 0;
  max-height: 2.4em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Chapter__bar button {
  position: absolute;
  right: 0;
  top: 13px;
}

.Chapter__content {
  border-top: 1px solid #3c4148;
}

.Chapter__description {
  color: #637b6e;
  font-weight: 700;
}

.Chapter__meta {
  font-size: 0.9em;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Chapter/Chapter.vue